<template>
	<o-page
		title="Tableau de bord"
		class="orion-page--full-width">
		<div class="row row--grid">
			<div
				class="col-xs-12">
				<dashboard-temp-worker-add-membership-marketing-card/>
			</div>

			<div
				id="temp-worker-calendar"
				class="col-md-12"/>
			<div class="row row--grid">
				<div
					class="col-sm-6">
					<dashboard-new-doc-or-sign-card
						type="notSigned"
						color="info"/>
				</div>
				<div class="col-sm-6">
					<dashboard-new-doc-or-sign-card
						type="notViewed"
						color="success"/>
				</div>
				<div class="col-sm-6">
					<dashboard-time-ticket-to-fill-card
						type="notViewed"
						color="success"/>
				</div>
				<div class="col-sm-6">
					<dashboard-pending-job-offer-card
						type="notViewed"
						color="success"/>
				</div>
			</div>

			<div
				v-if="setup.showProfileCompletion"
				class="col-xs-12 col-lg-12">
				<dashboard-profile-completion-card @hide="setup.showProfileCompletion = false"/>
			</div>

			<div
				v-if="setup.showSalaryCurrentYear && setup.responsive.onTabletPortrait"
				class="col-xs-12">
				<dashboard-temp-worker-salary-current-year-card @hide="setup.showSalaryCurrentYear = false"/>
			</div>
		</div>

		<teleport
			v-if="setup.elem"
			:to="setup.teleportComponent">
			<dashboard-temp-worker-calendar/>
		</teleport>
	</o-page>
</template>

<script setup lang="ts">
import DashboardTempWorkerSetupService from '@/setup/dashboard/temp-worker/DashboardTempWorkerSetupService';
import DashboardNewDocOrSignCard from '@/components/dashboard/DashboardNewDocOrSignCard.vue';
import DashboardTimeTicketToFillCard from '@/components/dashboard/DashboardTimeTicketToFillCard.vue';
import DashboardPendingJobOfferCard from '@/components/dashboard/DashboardPendingJobOfferCard.vue';
import DashboardTempWorkerAddMembershipMarketingCard from '@/components/dashboard/temp-worker/DashboardTempWorkerAddMembershipMarketingCard.vue';
import DashboardProfileCompletionCard from '@/components/dashboard/DashboardProfileCompletionCard.vue';
import DashboardTempWorkerCalendar from '@/components/dashboard/temp-worker/DashboardTempWorkerCalendar.vue';
import DashboardTempWorkerSalaryCurrentYearCard from '@/components/dashboard/temp-worker/DashboardTempWorkerSalaryCurrentYearCard.vue';
const setup = new DashboardTempWorkerSetupService();
</script>
